import { faGift, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { displayPopin } from "../../Hook/popins";
import useUser from "../../Hook/user";
import "./dailyspinbanner.css";

const DISMISS_DURATION = 24 * 60 * 60 * 1000;
const STORAGE_KEY = "dailySpinBannerDismissed";

function DailySpinBanner() {
  const user = useUser();
  const display = displayPopin();
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    const dismissedAt = localStorage.getItem(STORAGE_KEY);
    if (dismissedAt) {
      const now = Date.now();
      if (now - parseInt(dismissedAt, 10) < DISMISS_DURATION) {
        setDismissed(true);
      } else {
        localStorage.removeItem(STORAGE_KEY);
        setDismissed(false);
      }
    } else {
      setDismissed(false);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
    setDismissed(true);
  };

  const handleClick = () => {
    display("dailyspin");
  };

  if (!user || !user.informations) return null;
  if (user.informations.type === "guest") return null;
  if (!user.informations.is_email_confirmed) return null;
  if (dismissed) return null;

  return (
    <div className="w-full flex justify-center px-4 sm:px-6 lg:px-8 py-4 mt-2">
      <div className="max-w-4xl w-full">
        <div className="relative overflow-hidden rounded-2xl shadow-lg bg-gradient-to-r from-[#d946ef] via-[#ec4899] to-[#fb923c]">
          {/* Close button */}
          <button
            onClick={handleDismiss}
            className="absolute top-3 right-3 p-2 text-white/70 hover:text-white transition-colors rounded-full hover:bg-white/10 z-10"
            aria-label="Dismiss"
          >
            <FontAwesomeIcon icon={faTimes} className="text-lg" />
          </button>

          {/* Decorative sparkles */}
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <div className="dailyspin-banner-sparkle absolute top-2 left-[10%] w-2 h-2 bg-white rounded-full opacity-60" />
            <div className="dailyspin-banner-sparkle absolute top-6 left-[30%] w-1.5 h-1.5 bg-yellow-200 rounded-full opacity-50 [animation-delay:0.4s]" />
            <div className="dailyspin-banner-sparkle absolute bottom-4 left-[60%] w-2 h-2 bg-white rounded-full opacity-40 [animation-delay:0.8s]" />
            <div className="dailyspin-banner-sparkle absolute top-3 right-[20%] w-1 h-1 bg-yellow-100 rounded-full opacity-70 [animation-delay:1.2s]" />
            <div className="dailyspin-banner-sparkle absolute bottom-3 left-[80%] w-1.5 h-1.5 bg-white rounded-full opacity-50 [animation-delay:0.6s]" />
          </div>

          <div className="px-6 sm:px-8 py-5 pr-12">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              {/* Icon and text */}
              <div className="flex items-center gap-4">
                <div className="flex-shrink-0">
                  <div className="dailyspin-banner-icon w-14 h-14 rounded-full bg-white/20 flex items-center justify-center border-2 border-white/40">
                    <FontAwesomeIcon icon={faGift} className="text-white text-2xl" />
                  </div>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-lg font-bold text-white">
                    <FormattedMessage id="dailyspin_banner__title" />
                  </p>
                  <p className="text-sm text-white/80 mt-0.5">
                    <FormattedMessage id="dailyspin_banner__description" />
                  </p>
                </div>
              </div>

              {/* CTA Button */}
              <div className="flex justify-center sm:justify-end sm:flex-shrink-0 sm:mr-4">
                <button
                  onClick={handleClick}
                  className="dailyspin-banner-cta bg-white text-[#d946ef] font-extrabold py-2.5 px-6 rounded-full text-sm uppercase tracking-wide shadow-md hover:shadow-lg transition-shadow whitespace-nowrap"
                >
                  <FormattedMessage id="dailyspin_banner__button" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DailySpinBanner;
